module.exports = "<div>\n  <div id=\"secureFrameWrapper\">\n  <iframe id=\"secureFrame\" class=\"secureFrame\" height=\"245px\" width=\"600px\" [src]=\"iFrameUrl\">\n    </iframe>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/MembriPay/src/app/components/payment/paymenttech-form/paymenttech-form-popup/paymenttech-form-popup.component.html
// module id = ../../../../../src/app/components/payment/paymenttech-form/paymenttech-form-popup/paymenttech-form-popup.component.html
// module chunks = main